import {
  EXPERTS_LAUNCH_SEGMENT,
  TOWNHOUSE_SEGMENT,
  VERTICAL_LIVING_SEGMENT
} from "../constants/segments";

const isSegmentType = segmentType => segment => segment === segmentType;

export const isExpertsLaunch = isSegmentType(EXPERTS_LAUNCH_SEGMENT);
export const isTownhouse = isSegmentType(TOWNHOUSE_SEGMENT);
export const isVerticalLiving = isSegmentType(VERTICAL_LIVING_SEGMENT);

export const switchSegmentName = (segmentName, returnValues) =>
  returnValues[segmentName] || null;
